import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from './../AuthContext';
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import { site_url, truck } from "./../config.js";
import { Formik } from 'formik';
import axios from 'axios';
import { IndianCurrencyFormatter, FormatDate } from './../Function';
import { useQuery } from '@tanstack/react-query';
import { Link, Navigate, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';

const transaction = async (user) => {
  try {
    const response = await axios.post(site_url + '/vendor/transtions', user);

    return response.data.transtions;  // Axios auto-parses JSON
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch transactions');
  }
};

function Index({ children }) {

  const { user, refreshUser, vendordetails } = useContext(AuthContext);
  const navigate = useNavigate();
  const [msg, setMsg] = useState([]);
  const [Iseligible, setIseligible] = useState(false);
  const [billcustomer, setbillcustomer] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState('cash');
  const [data, setdata] = useState([]);
  const [billamount, setbillamount] = useState([]);
  const today = new Date().toISOString().split("T")[0]; // yyyy-mm-dd format
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [adminDenominations, setAdminDenominations] = useState([]);
  const [adminRoutes, setAdminRoutes] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState('all');
  const [loadingAdmin, setLoadingAdmin] = useState(false);

  const shopdetails = () => {
    routepath();
    // your API call / filter logic here
  };


  const showSuccessAlert = () => {
    Swal.fire({
      title: 'Success!',
      text: 'Order placed successfully',
      icon: 'success',
      confirmButtonText: 'OK',
    });
  };


  const handleSubmit = async (values, { setSubmitting, resetForm }) => {

    try {

      // API request
      const data = {
        "customerid": billcustomer.customer.id,
        "billamount": values.billamount,
        "billno": values.billno,
        "tax": values.tax,
        "paytype": paymentMethod,
        "vendorid": user.id,
      }
      const response = await axios.post(site_url + '/vendor/billpay', data);
      console.log(response);
      if (response.data.status == 'success') {
        resetForm();
        setbillcustomer();
        refreshUser();
        //  refetchtransactions();
        showSuccessAlert();
        setMsg(response.data)
      } else if (response.data.status == 'failed') {
        setMsg(response.data)
      }
      // Reset form after success
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false); // Stop loading spinner
    }
  };


  const routepath = async () => {
    try {
      let response;
      if (user.w_type == 1) {
        const data = {
          fromdate: fromDate,
          todate: toDate
        }
        response = await axios.post(site_url + '/view_collection_data_route', data);

      } else {
        response = await axios.get(site_url + '/routebasecollectionamount/' + user.id+'/'+fromDate);

      }
      if (response.data.status == 'success') {
        setdata(response.data.category_totals);
        console.log(response.data.category_totals);
      }
    } catch (error) {

    }
  }



  const totalbill = async () => {
    try {
      const response = await axios.get(site_url + '/totalbill/' + user.id);
      if (response.data.status == 'success') {
        setbillamount(response.data.order);
      }
    } catch (error) {

    }
  }
  // Fetch routes for admin
  const fetchAdminRoutes = async () => {
    try {
      const response = await axios.get(site_url + '/shop_cates');
      if (response.data && response.data.status === 'success') {
        setAdminRoutes(response.data.category || []);
      }
    } catch (error) {
      console.error('Error fetching routes:', error);
    }
  };

  // Fetch denominations for admin
  const fetchAdminDenominations = async () => {
    if (user.id != 1) return;
    
    setLoadingAdmin(true);
    try {
      const response = await axios.post(site_url + '/get-denominations-list', {
        w_id: null,
        fromdate: fromDate,
        todate: toDate,
        routeid: selectedRoute === 'all' ? null : selectedRoute
      });
      
      if (response.data && response.data.status === 'success') {
        setAdminDenominations(response.data.denominations || []);
      }
    } catch (error) {
      console.error('Error fetching admin denominations:', error);
    } finally {
      setLoadingAdmin(false);
    }
  };

  useEffect(() => {
    routepath();
    totalbill();
    
    if (user.id == 1) {
      fetchAdminRoutes();
      fetchAdminDenominations();
    }
  }, [user.id]);

  useEffect(() => {
    if (user.id == 1) {
      fetchAdminDenominations();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromDate, toDate, selectedRoute]);



  return (
    <>

      <div id="appCapsule">
        {/* Wallet Card */}
        <div className="section wallet-card-section pt-1">
          <div className="wallet-card">
            {/* Balance */}
            <div className="balance">
              <div className="left">
                {/* <h2 className="title">Today Bill Amount</h2>
                <h1 className="total">₹ {(billamount ? billamount : '0')}</h1> */}
              </div>
              <div className="right">

              </div>
            </div>

          </div>
        </div>


        <div className="section mt-4">
          {(user.id == 1) ? (<> 
            <div className="section-heading mb-3">
              <h2>Denomination Report</h2>
            </div>

            {/* Admin Filters */}
            <div className="card mb-3">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        max={toDate}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        min={fromDate}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Route</label>
                      <select
                        className="form-control"
                        value={selectedRoute}
                        onChange={(e) => setSelectedRoute(e.target.value)}
                      >
                        <option value="all">All Routes</option>
                        {adminRoutes.map((route) => (
                          <option key={route.id} value={route.id}>
                            {route.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3 d-flex align-items-end">
                    <button
                      className="btn btn-primary w-100"
                      onClick={fetchAdminDenominations}
                      disabled={loadingAdmin}
                    >
                      {loadingAdmin ? 'Loading...' : 'Filter'}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Admin Denomination Table */}
            <div className="card">
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-bordered table-hover mb-0">
                    <thead style={{background: '#4B49AC', color: 'white'}}>
                      <tr>
                        <th>Worker Name</th>
                        <th>Route</th>
                        <th>Collection Date</th>
                        <th>Route Total</th>
                        <th>Collection Total</th>
                        <th>Balance</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingAdmin ? (
                        <tr>
                          <td colSpan="7" className="text-center p-4">
                            <p>Loading...</p>
                          </td>
                        </tr>
                      ) : adminDenominations.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center p-4">
                            <p>No denominations found</p>
                          </td>
                        </tr>
                      ) : (
                        adminDenominations.map((denom) => {
                          const routeTotal = parseFloat(denom.totalcollectionamount || 0);
                          const collectionTotal = parseFloat(denom.totalrouteamount || 0);
                          const balance = routeTotal - collectionTotal;
                          
                          return (
                            <tr 
                              key={denom.id} 
                              style={{cursor: 'pointer'}}
                              onClick={() => navigate(`/Denominationdetailsview?id=${denom.id}&w_name=${denom.w_name}`)}
                            >
                              <td>{denom.w_name || 'N/A'}</td>
                              <td>{denom.route_name || `Route ${denom.routeid}`}</td>
                              <td>{FormatDate(denom.collectiondate) || denom.collectiondate}</td>
                              <td className="text-primary">₹ {routeTotal.toLocaleString('en-IN', {minimumFractionDigits: 2})}</td>
                              <td className="text-success">₹ {collectionTotal.toLocaleString('en-IN', {minimumFractionDigits: 2})}</td>
                              <td className={balance >= 0 ? 'text-warning' : 'text-danger'}>
                                ₹ {balance.toLocaleString('en-IN', {minimumFractionDigits: 2})}
                              </td>
                              <td onClick={(e) => e.stopPropagation()}>
                                <Link 
                                  to={`/Denominationdetailsview?id=${denom.id}&w_name=${denom.w_name}`}
                                  className="btn btn-sm btn-info"
                                >
                                  View Details
                                </Link>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Floating Total Balance for Admin */}
            {adminDenominations.length > 0 && (
              <div style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                backgroundColor: '#fff',
                boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
                padding: '15px 20px',
                zIndex: 1000,
                borderTop: '2px solid #4B49AC'
              }}>
                <div className="container">
                  <div className="row align-items-center">
                    <div className="col-md-4">
                      <strong>Total Route Amount:</strong>
                      <h4 className="mb-0 text-primary">
                        ₹ {adminDenominations.reduce((sum, d) => sum + parseFloat(d.totalcollectionamount || 0), 0).toLocaleString('en-IN', {minimumFractionDigits: 2})}
                      </h4>
                    </div>
                    <div className="col-md-4">
                      <strong>Total Collection Amount:</strong>
                      <h4 className="mb-0 text-success">
                        ₹ {adminDenominations.reduce((sum, d) => sum + parseFloat(d.totalrouteamount || 0), 0).toLocaleString('en-IN', {minimumFractionDigits: 2})}
                      </h4>
                    </div>
                    <div className="col-md-4 text-end">
                      <strong>Total Balance:</strong>
                      <h3 className={`mb-0 ${adminDenominations.reduce((sum, d) => {
                        const routeTotal = parseFloat(d.totalcollectionamount || 0);
                        const collectionTotal = parseFloat(d.totalrouteamount || 0);
                        return sum + (routeTotal - collectionTotal);
                      }, 0) >= 0 ? 'text-warning' : 'text-danger'}`}>
                        ₹ {adminDenominations.reduce((sum, d) => {
                          const routeTotal = parseFloat(d.totalcollectionamount || 0);
                          const collectionTotal = parseFloat(d.totalrouteamount || 0);
                          return sum + (routeTotal - collectionTotal);
                        }, 0).toLocaleString('en-IN', {minimumFractionDigits: 2})}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Bottom padding for floating footer */}
            <div style={{ height: adminDenominations.length > 0 ? '120px' : '0' }}></div>

          </>):(<>
        
          <div className="section-heading mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <h2>Denomination</h2>
              <Link to="/Denominationlist" className="btn btn-primary btn-sm">
                Denomination List
              </Link>
            </div>
          </div>

          {/* Total Amount Card */}
          {data && data.length > 0 && (
            <div className="card mb-3" style={{backgroundColor: '#4B49AC', color: 'white'}}>
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="mb-0" style={{color: 'white', fontWeight: 'normal'}}>Total Amount</h5>
                  </div>
                  <div>
                    <h3 className="mb-0" style={{color: 'white', fontWeight: 'bold'}}>
                      ₹ {data.reduce((sum, item) => sum + (parseFloat(item.sales_amount) || 0), 0).toLocaleString('en-IN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          )}
          
          <div className="transactions">

      
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label>Denomination Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      max={toDate}
                    />
                  </div>
                </div>

                {/* To Date */}
                {/* <div className="col-md-4">
                  <div className="form-group">
                    <label>To Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      min={fromDate}
                    />
                  </div>
                </div> */}

                {/* Filter Button */}
                <div className="col-md-4 d-flex align-items-end">
                  <button
                    className="btn btn-primary w-100"
                    onClick={shopdetails}
                    disabled={!fromDate}
                  >
                    Filter
                  </button>
                </div>
              </div>
              <br></br>
           

            {data?.map((item) => (


              <Link to={`/Denominationcal?id=${item.id}&sales_amount=${item.sales_amount}&w_type=${user.w_type}&date=${fromDate}`} className="item">

                <div className="detail">
                  <img
                    src={truck}
                    alt="img"
                    className="image-block imaged w48"
                  />
                  <div>
                    <strong>{item.name}</strong>
                    <h3 style={{fontWeight: 'bold'}}>₹ {item.sales_amount}</h3>
                  </div>
                </div>
                <div className="right">
                  <div className="price text-danger">
                  </div>
                </div>
              </Link>

            ))}



          </div>
          </>)}
        </div>
      
      </div>
      <Footer />
      <Sidebar />



    </>

  )
}
const styles = {
  container: {
    textAlign: 'center',
    padding: '15px',
    fontFamily: 'Arial, sans-serif',
  },
  optionContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    marginTop: '15px',
  },
  option: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '15px 30px',
    border: '2px solid #ccc',
    borderRadius: '10px',
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',
    fontSize: '15px',
    width: '130px',
    height: '50px'
  },
  selectedOption: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '15px 30px',
    border: '2px solid #28a745',
    borderRadius: '10px',
    cursor: 'pointer',
    backgroundColor: '#28a745',
    color: '#fff',
    fontSize: '17px',
    width: '130px',
    height: '50px'
  },
  icon: {
    fontSize: '16px',
  },
  result: {
    marginTop: '20px',
    fontSize: '16px',
  },
};

// Add CSS styles for dashboard cards
const dashboardStyles = `
  .dashboard-card {
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    transition: all 0.3s ease;
    text-decoration: none;
    color: inherit;
    background: #fff;
    min-height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .dashboard-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0,0,0,0.15);
    text-decoration: none;
    color: inherit;
  }
  
  .dashboard-icon {
    font-size: 2rem;
    color: #007bff;
    margin-bottom: 8px;
  }
  
  .dashboard-card .card-title {
    font-size: 0.9rem;
    font-weight: 600;
    margin: 0;
    color: #333;
  }
  
  .dashboard-card .card-body {
    padding: 1rem;
  }
  
  @media (max-width: 768px) {
    .dashboard-card {
      min-height: 80px;
    }
    
    .dashboard-icon {
      font-size: 1.5rem;
    }
    
    .dashboard-card .card-title {
      font-size: 0.8rem;
    }
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = dashboardStyles;
  document.head.appendChild(styleSheet);
}

export default Index